import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPaginationParams } from '../interfaces/IPaginationParamas';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class WorkAreasService {
  constructor(private http: HttpClient) {}
  createWorkArea(workAreaData: any) {
    return this.http.post<ApiResponse>('/v1/admin/work-areas', workAreaData);
  }
  getAllWorkArea(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    return this.http.get<ApiResponse>('/v1/admin/work-areas', { params: httpParams });
  }
  getWorkAreaById(id: string | null) {
    return this.http.get<ApiResponse>(`/v1/admin/work-areas/${id}`);
  }
  updateWorkArea(id: string | null, workAreaData: any) {
    return this.http.put<ApiResponse>(`/v1/admin/work-areas/${id}`, workAreaData);
  }
  deleteWorkArea(id: string) {
    return this.http.delete<ApiResponse>(`/v1/admin/work-areas/${id}`);
  }
  exportWorkareas(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/work-areas/export`, filterData, options);
  }
}
